import { parseISO } from 'date-fns'
import dayjs from 'dayjs'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import Message from '../../../components/Message'
import NotFound404 from '../../../components/NotFound404'
import DatePicker from '../../../components/v2/DatePicker'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useAppDispatch, useAppSelector } from '../../../store'
import { TravelAbroadState, setSingleDates } from '../../../store/travelAbroadSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { Helmet } from 'react-helmet-async'
//
//
const SingleSelectDate = () => {
  //
  //
  // insurance kinds
  const { data: insuranceKinds, isLoading: isInsuranceKindsLoading } = api.useGetInsuranceKindsQuery(undefined)
  // get product package min price single & multi
  const { data: TravelSingleOrMultiPrice, isLoading: isTravelSingleOrMultiPriceLoading } =
    api.useGetTravelSingleOrMultiPriceQuery(undefined)
  //
  //
  const DataFropApi = insuranceKinds && TravelSingleOrMultiPrice
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  //
  const MainLoading = isTravelSingleOrMultiPriceLoading || isInsuranceKindsLoading
  //
  //
  const maxDate = dayjs(filter.singleDates?.start).add(365, 'day').format('YYYY-MM-DD')
  //
  //
  const [getLeftCompanies, { data: leftCompanies }] = api.useTravelAbrodLeftCompaniesMutation()
  //
  useEffect(() => {
    if (filter.productCategory && filter.singleOrMulti && filter.singleDates?.start && filter.singleDates?.end) {
      const GetCompaniesFunction = async () => {
        try {
          await getLeftCompanies({
            step: 'step-two',
            productCategory: filter.productCategory,
            startDate: filter.singleDates?.start as string,
            endDate: filter.singleDates?.end as string,
            travelType: filter.singleOrMulti,
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (GetCompaniesFunction) (single)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [
    filter.singleOrMulti,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.productCategory,
    getLeftCompanies,
  ])
  //
  //
  const datesIsValid = (start: any, end: any) => {
    const startDateObj = dayjs(start)
    const endDateObj = dayjs(end)

    if (startDateObj.isValid() && endDateObj.isValid()) {
      return startDateObj.isBefore(endDateObj)
    }

    return false
  }
  //
  //
  const getDayDifference = (startDate: any, endDate: any) => {
    const start = dayjs(startDate, 'YYYY-MM-DD') // Replace 'YYYY-MM-DD' with your date format
    const end = dayjs(endDate, 'YYYY-MM-DD') // Replace 'YYYY-MM-DD' with your date format
    const diffInDays = end.diff(start, 'day')
    return diffInDays + 1
  }
  //
  //
  return MainLoading ? (
    <Loader />
  ) : !DataFropApi ? (
    <NotFound404 />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('multiSelectStartDate')}</title>
        <meta name="description" content={`${t('multiSelectStartDate')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('multiSelectStartDate')} />

        <AbroadProgressBar stepName={`${t('period')}`} />

        <FlexBlock>
          <NumberOfDays
            style={{
              opacity: filter.singleDates?.start && filter.singleDates?.end ? '1' : '0',
            }}
          >
            {t('numberOfDays')}: {getDayDifference(filter.singleDates?.start, filter.singleDates?.end)}
          </NumberOfDays>

          <WhiteBox>
            <DatePicker
              minDate={new Date()}
              className="start-date-class"
              label={`${t('startDate')}`}
              dateFormat="dd MMMM yyyy"
              selectedDate={filter.singleDates?.start ? parseISO(filter.singleDates.start as string) : null}
              onchange={(value) =>
                dispatch(
                  setSingleDates({
                    start: dayjs(value).format('YYYY-MM-DD'),
                    end: filter.singleDates?.end || null,
                  }),
                )
              }
            />

            <br />

            {filter.singleDates?.start &&
            filter.singleDates?.end &&
            datesIsValid(filter.singleDates?.start, filter.singleDates?.end) === false ? (
              <Message text="დაწყების თარიღი წინ არ უნდა უსწრებდეს დასრულების თარიღს" variant="light-red" />
            ) : null}
          </WhiteBox>

          {filter.singleDates?.start ? (
            <>
              <WhiteBox>
                <DatePicker
                  minDate={
                    filter.singleDates?.start
                      ? parseISO(dayjs(filter?.singleDates.start).add(1, 'day').format('YYYY-MM-DD'))
                      : null
                  }
                  maxDate={parseISO(maxDate) || null}
                  className="end-date-class"
                  label={`${t('endDate')}`}
                  dateFormat="dd MMMM yyyy"
                  selectedDate={filter.singleDates?.end ? parseISO(filter.singleDates.end as string) : null}
                  onchange={(value) =>
                    dispatch(
                      setSingleDates({
                        start: filter.singleDates?.start || null,
                        end: dayjs(value).format('YYYY-MM-DD'),
                      }),
                    )
                  }
                />
              </WhiteBox>

              <RemainingCompanies
                style={{
                  opacity: leftCompanies ? '1' : '0',
                }}
                text={`${t('offerAvailable')}: ${leftCompanies?.length} `}
              />
            </>
          ) : null}
        </FlexBlock>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/category')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            onClick={() => navigate('/select-region')}
            disabled={
              filter.singleOrMulti &&
              filter.productCategory &&
              filter.singleDates?.start &&
              filter.singleDates.end &&
              leftCompanies &&
              leftCompanies.length >= 1 &&
              datesIsValid(filter.singleDates?.start, filter.singleDates?.end) === true
                ? false
                : true
            }
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const NumberOfDays = styled.p`
  margin-bottom: 12px;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 32px;
  text-align: left;
  margin-right: auto;

  ${Responsive.mobile} {
    margin-top: 24px;
    margin-bottom: 10px;
  }
`
const WhiteBox = styled.div`
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 ${Colors.shadow};
  border-radius: 8px;
  padding: 40px 48px;
  width: 100%;

  &:nth-child(2) {
    margin-bottom: 24px;
    /* margin-top: 32px; */
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-popper {
    position: unset !important;
    transform: unset !important;
    margin-top: 10px;
  }
  .react-datepicker {
    display: flex;
    justify-content: center;
  }

  ${Responsive.mobile} {
    padding: 32px 20px;

    &:first-child {
      margin-top: 24px;
      margin-bottom: 20px;
    }
  }
`

const FlexBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 464px;
  width: 100%;
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  user-select: none;
  min-height: 100vh;
  /*  */
`
//
export default SingleSelectDate
